require("!!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/script-loader/addScript.js")(require("!!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/raw-loader/index.js!/var/lib/jenkins/workspace/TEST2/webapp/src/main/webapp/js/extensions/window.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/main/webapp/js/extensions/window.js
// module id = 171
// module chunks = 37